var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconCreditCard = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 52,
  height: 24,
  viewBox: "0 0 52 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2027)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  width: 24,
  height: 24,
  transform: "translate(2055)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2057 4.689)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.013 13.185)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2952.005,2901.035V2900a.6.6,0,0,0-.652-.652.679.679,0,0,0-.584.292.6.6,0,0,0-.549-.292.554.554,0,0,0-.481.24v-.206h-.36v1.648h.36v-.909c0-.292.155-.429.4-.429s.361.155.361.429v.909h.36v-.909a.38.38,0,0,1,.395-.429c.241,0,.361.155.361.429v.909Zm5.339-1.648h-.584v-.5h-.36v.5h-.326v.326h.326v.755c0,.378.154.6.566.6a.962.962,0,0,0,.447-.12l-.1-.309a.565.565,0,0,1-.309.086c-.172,0-.241-.1-.241-.275v-.738h.584Zm3.056-.034a.482.482,0,0,0-.429.24v-.206h-.36v1.648h.36v-.927c0-.275.12-.429.343-.429a1,1,0,0,1,.223.034l.1-.344a1.175,1.175,0,0,0-.241-.017Zm-4.618.171a1.178,1.178,0,0,0-.669-.171c-.413,0-.687.206-.687.532,0,.275.206.429.567.48l.171.018c.189.034.292.085.292.171,0,.12-.137.206-.377.206a.952.952,0,0,1-.55-.172l-.171.274a1.215,1.215,0,0,0,.7.206c.481,0,.756-.223.756-.532,0-.292-.224-.446-.566-.5l-.172-.017c-.155-.018-.275-.052-.275-.155,0-.12.12-.188.31-.188a1.229,1.229,0,0,1,.514.137Zm9.579-.171a.482.482,0,0,0-.429.24v-.206h-.361v1.648h.361v-.927c0-.275.12-.429.343-.429a1,1,0,0,1,.224.034l.1-.344a1.175,1.175,0,0,0-.241-.017Zm-4.6.858a.825.825,0,0,0,.876.858.851.851,0,0,0,.583-.188l-.171-.292a.693.693,0,0,1-.43.154.488.488,0,0,1-.5-.532.507.507,0,0,1,.5-.532.694.694,0,0,1,.43.154l.171-.292a.851.851,0,0,0-.583-.188.825.825,0,0,0-.876.858Zm3.331,0v-.824h-.36v.206a.619.619,0,0,0-.515-.24.859.859,0,0,0,0,1.716.577.577,0,0,0,.515-.24v.206h.36Zm-1.321,0a.5.5,0,1,1,1,0,.5.5,0,1,1-1,0Zm-4.31-.858a.859.859,0,0,0,.018,1.716,1.054,1.054,0,0,0,.669-.223l-.172-.258a.82.82,0,0,1-.481.172.463.463,0,0,1-.5-.4h1.219v-.137a.758.758,0,0,0-.755-.875Zm0,.309a.4.4,0,0,1,.412.395h-.858a.434.434,0,0,1,.446-.395Zm8.944.549v-1.477h-.36v.859a.62.62,0,0,0-.515-.24.859.859,0,0,0,0,1.716.577.577,0,0,0,.515-.24v.206h.36Zm-1.322,0a.5.5,0,1,1,1,0,.5.5,0,1,1-1,0Zm-12.052,0v-.824h-.36v.206a.62.62,0,0,0-.515-.24.859.859,0,0,0,0,1.716.578.578,0,0,0,.515-.24v.206h.36Zm-1.339,0a.5.5,0,1,1,1,0,.5.5,0,1,1-1,0Z",
  transform: "translate(-2949.379 -2898.734)"
})), /*#__PURE__*/React.createElement("rect", {
  fill: "#ff5f00",
  width: 5.408,
  height: 9.717,
  transform: "translate(7.296 1.322)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#eb001b",
  d: "M2906.374,2245.682a6.2,6.2,0,0,1,2.352-4.858,6.18,6.18,0,1,0,0,9.717A6.17,6.17,0,0,1,2906.374,2245.682Z",
  transform: "translate(-2898.734 -2239.501)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f79e1b",
  d: "M3409.159,2245.682a6.174,6.174,0,0,1-9.991,4.858,6.194,6.194,0,0,0,0-9.717,6.173,6.173,0,0,1,9.991,4.858Z",
  transform: "translate(-3389.159 -2239.501)"
}))), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  width: 24,
  height: 24,
  transform: "translate(2027)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1a1f71",
  fillRule: "evenodd",
  d: "M90.343,137.48c-.011.9.8,1.4,1.414,1.7.629.306.841.5.838.777,0,.419-.5.6-.967.611a3.377,3.377,0,0,1-1.659-.395l-.292,1.369a4.864,4.864,0,0,0,1.8.332c1.7,0,2.808-.838,2.814-2.137.007-1.649-2.28-1.74-2.265-2.477.005-.223.219-.462.686-.523a3.042,3.042,0,0,1,1.593.279l.284-1.324a4.331,4.331,0,0,0-1.512-.277c-1.6,0-2.721.849-2.73,2.065m6.972-1.951a.737.737,0,0,0-.688.458L94.2,141.776h1.7l.338-.933h2.073l.2.933H100l-1.3-6.247Zm.237,1.688.489,2.346H96.7Zm-9.265-1.688-1.337,6.247h1.616l1.336-6.247Zm-2.391,0-1.682,4.252-.68-3.615a.753.753,0,0,0-.745-.637h-2.75l-.038.181a6.726,6.726,0,0,1,1.594.531.684.684,0,0,1,.384.549l1.289,4.985h1.708l2.618-6.247Z",
  transform: "translate(1948.5 -126.32)"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCreditCard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-CreditCard.b64b4f63.svg";
export { ForwardRef as ReactComponent };